<section class="login">
  <div class="overlay"></div>

  <header class="hero">
    <div *ngIf="!isInstalled()">
      <button
        type="button"
        class="installation-link"
        data-testid="open-installation-modal"
        (click)="openInstallationModal()">
        <span class="installation-link__text">ACCEDE EN UN SOLO CLIC</span>
      </button>
    </div>


    <div class="brand">
      <img [src]="getLogoPath()" alt="">
    </div>

    <div class="actions">
      <a *ngFor="let a of topActions" (click)="openAction(a)" class="action-link">
        <round-button [label]="a.label" class="action-btn"></round-button>
      </a>
    </div>

    <h1>¡Bienvenido! ¡Welcome!</h1>
    <p class="select-lang">Selecciona tu idioma. Select your language.</p>
    <div class="lang-selector">
      <lang-selector></lang-selector>
    </div>
  </header>

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="one-time-code">
    <p>Introduce tu código de huésped</p>
    <label for="guest-code" class="visually-hidden">Código de huésped</label>
    <div class="input-wrap">
      <img src="/images/login-person.png" alt="Usuario" class="input-icon">
      <input id="guest-code" data-testid="guest-code-input" class="input" name="guestCode" formControlName="guestCode" placeholder="Código de huésped" required/>
    </div>
    <round-button data-testid="login-submit" [label]="'Entrar'" type="submit" [disabled]="disabledSubmit()" class="button-primary"></round-button>
    <label class="toggle" data-testid="accept-terms-toggle">
      <input type="checkbox" formControlName="aceptaCondiciones"/>
      <span class="toggle__switch"></span>
      <span class="toggle__text">
          He leído y acepto los <a routerLink="/terms-and-conditions" class="toggle__link">Términos y Condiciones</a>
        </span>
    </label>
  </form>

  <footer class="footer">
    <hv-logo></hv-logo>
  </footer>
  <modal-install-info
    [show]="showInstallInfoModal()"
    [showCloseButton]="true"
    (install)="installPWA()"
    (close)="closeInstallInfoModal()"
    *ngIf="showInstallInfoModal()">
  </modal-install-info>
</section>
